module.exports = __webpack_public_path__ + "img/farina_cahm.79bbc237.jpg";